import React, { useEffect, useState, useRef, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import api from '../components/api';
import { dataTableRender, sleep } from '../components/functions'
import moment from 'moment'
import axios from 'axios'
import ModalInscritoEvento from '../modals/inscritoEvento'
import JoditEditor from "jodit-react"
import InputMask from 'react-input-mask'

import DatePicker from "react-datepicker";
import MaskedInput from 'react-maskedinput';
import { registerLocale } from  "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR';

import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import "@fortawesome/fontawesome-free/css/all.min.css";

import "react-datepicker/dist/react-datepicker.css";

import FotosEvento from '../components/FotosEvento'
import ModalEmailConfirmacaoMassa from '../modals/emailConfirmacaoEventoMassa'


//import { CKEditor } from "ckeditor4-react";



const Evento = (props) => {

    //var linkAPI = 'http://172.16.1.253:3600/'
    //var linkAPI = 'https://api.hospitaissaudaveis.org/'
    var linkAPI = process.env.REACT_APP_API

    const [rowSelection, setRowSelection] = useState({});


    const history = useHistory()

    var [evento_id, setEvento_id] = useState(props.match.params.evento_id)

    var [linkDivulgacao, setLinkDivulgacao] = useState()

    var [nome, setNome] = useState()
    var [local, setLocal] = useState()
    var [endereco, setEndereco] = useState()
    var [data_inicio, setData_inicio] = useState()
    var [data_fim, setData_fim] = useState()
    var [email_responsavel, setEmail_responsavel] = useState()
    var [ativo, setAtivo] = useState()
    var [vagas, setVagas] = useState()
    var [data_limite, setData_limite] = useState()
    var [resultadoInscritos, setResultadoInscritos] = useState([])
    var [urlDivulgacao, setUrlDivulgacao] = useState()
    var [urlCertificados, setUrlCertificados] = useState()
    var [totalInscritos, setTotalInscritos] = useState(0)

    var [tipo, setTipo] = useState('')
    var [linkEvento, setLinkEvento] = useState('')

    var [cpf, setCPF] = useState()

    var [programacao, setProgramacao] = useState('')

    
    var [imagem, setImagem] = useState('')
    var [file, setFile] = useState('')

    var [inscricao_id, setInscricao_id] = useState()
    var [habPresenca, setHabPresenca] = useState(false)
    var [horaInicio, setHoraInicio] = useState('')
    var [horaTermino, setHoraTermino] = useState('')

    var [totalFotos, setTotalFotos] = useState(0)
    
    const [fileBanner, setFileBanner] = useState('')
    const [imagemBanner, setImagemBanner] = useState('')

    const [marcados, setMarcados] = useState('')

    const editor = useRef(null)
    const [content, setContent] = useState('')

    const [inscricao_id_array, setInscricao_id_array] = useState([])

    const [config, setConfig] = useState({
        readonly: false,
        toolbar: true,
        height: 300,
        placeholder: 'Escreva aqui...',
      })


    function voltar() {

        //history.push('/Eventos')
        history.goBack()

    }


    

    const columns = useMemo(
        () => [
        
         
          {
                accessorKey: 'data_inscricao',
                header: 'Data inscrição',
                accessorFn: (row) => {
                // Divide a data da hora
                const [datePart, timePart] = row.data_inscricao.split(' ');
                const [year, month, day] = datePart.split('-');
            
                // Junta no formato ISO reconhecido pelo JavaScript
                return new Date(`${year}-${month}-${day}T${timePart}`);
                },
                Cell: ({ cell }) => {
                const date = cell.getValue();
                return date instanceof Date && !isNaN(date)
                    ? moment(date).format('DD/MM/YYYY HH:mm:ss')
                    : '';
                },
                sortingFn: 'datetime',
                muiTableHeadCellProps: {
                align: 'center',
                },
                muiTableBodyCellProps: {
                align: 'center',
                },
            },
          {
            accessorKey: 'cpf',
            header: 'CPF',
          },
          {
            accessorKey: 'nome',
            header: 'Nome',
          },
          {
            accessorKey: 'email',
            header: 'E-mail',
          },
          {
            accessorKey: 'nome_organizacao',
            header: 'Org.',
          },

          {
            accessorKey: 'categoria_profissional_descricao',
            header: 'Cargo',
          },

          {
            accessorKey: 'confirmado',
            header: 'Confirmado',
            Cell: ({ renderedCellValue, row }) => (
            
                <span class={`label label-${ renderedCellValue == true ? 'success' : 'danger' }`}>{renderedCellValue == true ? 'Sim' : 'Não'}</span>
           
            ),
          },
          {
            accessorKey: 'envioLink',
            header: 'E-mail acesso',
            Cell: ({ renderedCellValue, row }) => (
            
                <span class={`label label-${ renderedCellValue == true ? 'success' : 'danger' }`}>{renderedCellValue == true ? 'Sim' : 'Não'}</span>
           
            ),
          },
          {
            accessorKey: 'presente',
            header: 'Presente',
            Cell: ({ renderedCellValue, row }) => (
            
                <span class={`label label-${ renderedCellValue == true ? 'success' : 'danger' }`}>{renderedCellValue == true ? 'Sim' : 'Não'}</span>
           
            ),
          },


        ],
        [],
      );

      /*


        <tr style={{ cursor: 'pointer'}} data-toggle="modal" data-target="#modalInscritoEvento" onClick={() => { setInscricao_id(rs.inscricao_id); setCPF(rs.cpf)}}>
            <td>
                {rs.data_inscricao}
            </td>
            <td>
                {rs.cpf}
            </td>
            <td>
                {rs.nome}
            </td>
            <td>
                {rs.email}
            </td>
            <td>
                {rs.nome_organizacao}
            </td>
            <td>
                {rs.categoria_profissional_descricao}
            </td>
            <td>
                <center>
                {rs.confirmado ? 'Sim' : 'Não'}
                </center>
            </td>
            <td>
                <center>
                {rs.envioLink ? 'Sim' : 'Não'}
                </center>
            </td>
            <td id={`presente${rs.inscrito_id}`}>
                <center>
                <div >{rs.presente ? 'Sim' : 'Não'}</div>
                </center>
            </td>
            */


    function exportarExcel() {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma exportar para Excel?',
		    buttons: {
		        Sim: function () {

                    

                    api.get(`inscritosExcel/${evento_id}`).then((result) => {

                            //console.log(`${linkAPI}/${result.data.arquivo}`)
                            //return false

                        sleep(1000).then(() => {

                            //window.location.href = `http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`
                            window.location.href = `${linkAPI}/${result.data.arquivo}`
        
                        })

                        
                        //setEvento_id(data.evento_id)

                    }).catch((err) => {

                        console.log(err.response)

                    })

                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

        

    }


    function salvar() {

        
        if (!moment(data_inicio, "DD/MM/YYYY", true).isValid()) {

            window.toastr.error('Data início inválida!')
            return false

        }

        if (!moment(data_fim, "DD/MM/YYYY", true).isValid()) {

            window.toastr.error('Data fim inválida!')
            return false

        }

        if (!moment(data_limite, "DD/MM/YYYY", true).isValid()) {

            window.toastr.error('Data limite inválida!')
            return false

        }

        if (tipo == null || tipo == '') {

            window.toastr.error('Por favor, informe o <b>tipo</b> do evento!')
            return false

        }
        

        var data_inicio_Env = moment(data_inicio, 'DD/MM/YYYY').format('YYYY-MM-DD')
        var data_fim_Env = moment(data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD')
        var data_limite_Env = moment(data_limite, 'DD/MM/YYYY').format('YYYY-MM-DD')
        
        

        //var data_fim = moment(data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD')
        //var data_limite = moment(data_limite, 'DD/MM/YYYY').format('YYYY-MM-DD')

        var dataPost = {

            nome: nome,
            local: local,
            endereco: endereco,
            data_inicio: data_inicio_Env,
            data_fim: data_fim_Env,
            email_responsavel: email_responsavel,
            vagas: vagas,
            data_limite: data_limite_Env,
            ativo: ativo,
            programacao: content,
            tipo: tipo,
            linkEvento: linkEvento,
            habPresenca: habPresenca,
            horaInicio: horaInicio,
            horaTermino, horaTermino,

        }

        //console.log(dataPost)
        //return false

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    if (evento_id != 'Novo') {

                        api.put(`evento/${evento_id}`, dataPost).then((response) => {
    
                            //console.log(response.data)
                            window.toastr.success('Salvo com sucesso!')
    
                        }).catch((err) => {
                            console.log(err.response)
                        })
    

                    } else {

                        api.post(`evento`, dataPost).then((result) => {

                            //console.log(result.data)
                            var data = result.data[0]

                            setEvento_id(data.evento_id)

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    }

                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

        
    }


    async function totalizaFotosEvento() {


        await api.get(`eventoFotosTotal/${evento_id}`).then((result) => {

            //console.log(result.data)
            setTotalFotos(result.data[0].total)

        }).catch((err) => {

            console.log(err.response)

        })

    }


    async function carregaEvento() {

        //console.log('!')

        await api.get(`evento/${evento_id}`).then((result) => {

            //console.log(result.data)

            var data = result.data[0]

            if (data) {


                var dateParts = data.data_inicio.split("/");
                var data_inicio = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])

                var dateParts = data.data_fim.split("/");
                var data_fim = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])

                var dateParts = data.data_limite.split("/");
                var data_limite = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])


                setNome(data.nome)
                setEndereco(data.endereco)
                setLocal(data.local)
                setData_inicio(data_inicio)
                setData_fim(data_fim)
                setVagas(data.vagas)
                setData_limite(data_limite)
                setEmail_responsavel(data.email_responsavel)
                setAtivo(data.ativo)
                setImagem(data.arte_certificado)
                setImagemBanner(data.banner)
                setTipo(data.tipo)
                setLinkEvento(data.linkEvento)

                setTotalInscritos(data.totalInscritos)

                setContent(data.programacao)
                setHabPresenca(data.habPresenca == null ? false : data.habPresenca)
                setHoraInicio(data.horaInicio)
                setHoraTermino(data.horaTermino)

                var link = `https://hospitaissaudaveis.org/Evento/${evento_id}`

                setLinkDivulgacao(link)
            }

        }).catch((err) => {

            console.log(err.response)

        })

    }


    function fotos() {


    }



    useEffect(() => {

        if (evento_id && evento_id != 'Novo') {

            carregaEvento()
            totalizaFotosEvento()

        }

    }, [evento_id])


    async function inscritos() {

        if (evento_id && evento_id != 'Novo') {

            await api.get(`inscritos/${evento_id}`).then((result) => {

                //console.log(result.data)

                /*
                setResultadoInscritos(result.data.map((rs) => 
                
                    <tr style={{ cursor: 'pointer'}} data-toggle="modal" data-target="#modalInscritoEvento" onClick={() => { setInscricao_id(rs.inscricao_id); setCPF(rs.cpf)}}>
                        <td>
                            {rs.data_inscricao}
                        </td>
                        <td>
                            {rs.cpf}
                        </td>
                        <td>
                            {rs.nome}
                        </td>
                        <td>
                            {rs.email}
                        </td>
                        <td>
                            {rs.nome_organizacao}
                        </td>
                        <td>
                            {rs.categoria_profissional_descricao}
                        </td>
                        <td>
                            <center>
                            {rs.confirmado ? 'Sim' : 'Não'}
                            </center>
                        </td>
                        <td>
                            <center>
                            {rs.envioLink ? 'Sim' : 'Não'}
                            </center>
                        </td>
                        <td id={`presente${rs.inscrito_id}`}>
                            <center>
                            <div >{rs.presente ? 'Sim' : 'Não'}</div>
                            </center>
                        </td>
                        
                       

                    </tr>
                
                ))

                dataTableRender('tabelaInscritos')
                */

                setResultadoInscritos(result.data)


            }).catch((err) => {

                console.log(err.response)

            })
        }
        
        
        
    }


    function apagar() {



        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {

                    

                    api.delete(`evento/${evento_id}`).then((result) => {

                        console.log(result.data)
                        window.toastr.success('Apagado com sucesso!')
                        history.push('/Eventos')

                    }).catch((err) => {

                        console.log(err.response)

                    })

                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }


    const uploadBanner = () => {




        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    

                    const formData = new FormData();
                    const imagefile = document.querySelector("#fileImgBanner");

                    

                    // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                    formData.append("imagemBanner", imagefile.files[0]);
                    //formData.append("evento_id", evento_id); // string junto ao formData.
                    
                    //console.log('altera')
                    //return false

                    axios.put(`${linkAPI}/eventoBanner/${evento_id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-access-token': '!nf0$@ud#2',
                    }
                    }).then(response => {

                        //console.log(response.data)
                        setImagemBanner(response.data.imagem)
                        setFileBanner('')

                        window.toastr.success('Salvo com sucesso!')



                    }).catch((err) => {

                        console.log(err.response)

                    })


                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }


    function uploadTemplate() {



        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    

                    const formData = new FormData();
                    const imagefile = document.querySelector("#fileImgCert");

                    

                    // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                    formData.append("imagemCertificado", imagefile.files[0]);
                    //formData.append("evento_id", evento_id); // string junto ao formData.
                    
                    //console.log('altera')
                    //return false

                    axios.put(`${linkAPI}/eventoCertificado/${evento_id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-access-token': '!nf0$@ud#2',
                    }
                    }).then(response => {

                        //console.log(response.data)
                        setImagem(response.data.imagem)
                        setFile('')

                        window.toastr.success('Salvo com sucesso!')



                    }).catch((err) => {

                        console.log(err.response)

                    })


                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    const changeHeaderText = (value) => {
        //console.log(value.editor.getData())
        setContent(value.editor.getData())
    }   


    const enviaMailSelecao = () => {

        
        const keys = Object.keys(rowSelection)
        const numericKeys = keys.map(Number);
        setInscricao_id_array(numericKeys)

        if (numericKeys.length == 0) {

            window.toastr.error('Por favor, selecione ao menos um registro!')
            return false

        } else {

            window.$('#ModalEmailConfirmacaoMassa').modal('show')

        }

        

    }


    return (

        <div>

            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-users'></i>
                </div>
                <div class='header-title'>
                    <h1>Evento</h1>
                    <small>Administração</small>
                    
                </div>
            </div>



        <div class="row">
                
            <div class="col-sm-12">
                
                

                <ul className="nav nav-tabs">
                        <li className="active"><a href="#tab1" data-toggle="tab">Dados do evento</a></li>
                        <li style={{ display: evento_id != 'Novo' ? 'table-row' : 'none'}}><a href="#tab4" data-toggle="tab" >Programação </a></li>
                        <li style={{ display: evento_id != 'Novo' ? 'table-row' : 'none'}}><a href="#tab3" data-toggle="tab" >Arte Certificado </a></li>
                        <li style={{ display: evento_id != 'Novo' ? 'table-row' : 'none'}}><a href="#tab6" data-toggle="tab" >Banner </a></li>
                        <li style={{ display: evento_id != 'Novo' ? 'table-row' : 'none'}}><a href="#tab2" data-toggle="tab" onClick={() => inscritos()}>Inscritos <span class="label label-info label-pill">{totalInscritos}</span></a></li>
                        <li style={{ display: evento_id != 'Novo' ? 'table-row' : 'none'}}><a href="#tab5" data-toggle="tab" onClick={() => fotos()}>Fotos <span class="label label-success label-pill">{totalFotos}</span></a></li>

                        
                    </ul>
                    
                    <div className="tab-content">
                        <div className="tab-pane fade in active" id="tab1">
                            <div className="panel-body">
                                    

                                <div className="col-md-9">
                                    <div className="form-group">
                                        <label>Nome do evento</label>
                                        <input type="text" className="form-control" placeholder="" value={nome} onChange={event => setNome(event.target.value)} maxLength="500"/>
                                                        
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Tipo</label>
                                        <select className="form-control" value={tipo} onChange={event => setTipo(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="P">Presencial</option>
                                            <option value="O">On-line</option>
                                        </select>
                                                        
                                    </div>
                                </div>
                                <div className="col-md-12" style={{ display: tipo == 'O' ? 'table-row' : 'none'}}>
                                    <div className="form-group">
                                        <label>Link do evento</label>
                                        <input type="text" class="form-control" placeholder="" value={linkEvento} onChange={event => setLinkEvento(event.target.value)} maxLength="1000" />
                                                        
                                    </div>
                                </div>
                                <div className="col-md-12" style={{ display: tipo == 'P' ? 'table-row' : 'none'}}>
                                    <div className="form-group">
                                        <label>Local</label>
                                        <input type="text" class="form-control" placeholder="" value={local} onChange={event => setLocal(event.target.value)} maxLength="255"/>
                                                        
                                    </div>
                                </div>
                                <div className="col-md-12" style={{ display: tipo == 'P' ? 'table-row' : 'none'}}>
                                    <div className="form-group">
                                        <label>Endereço</label>
                                        <input type="text" class="form-control" placeholder="" value={endereco} onChange={event => setEndereco(event.target.value)} maxLength="500" />
                                                        
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Data início</label>
                                        <DatePicker selected={data_inicio} onChange={(date) => setData_inicio(date)} className="form-control" locale="ptBR" dateFormat="dd/MM/yyyy" placeHolder="DD/MM/AAAA"
                                        customInput={
                                            <MaskedInput mask="11/11/1111" placeholder="mm/dd/yyyy" />
                                            } />
                                                        
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Data fim</label>
                                        <DatePicker selected={data_fim} onChange={(date) => setData_fim(date)} className="form-control" locale="ptBR" dateFormat="dd/MM/yyyy" placeHolder="DD/MM/AAAA"
                                        customInput={
                                            <MaskedInput mask="11/11/1111" placeholder="mm/dd/yyyy" />
                                            } />
                                                        
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Vagas</label>
                                        <input type="number" class="form-control" placeholder="" value={vagas} onChange={event => setVagas(event.target.value)} />
                                                        
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Data limite para inscrição</label>
                                        <DatePicker selected={data_limite} onChange={(date) => setData_limite(date)} className="form-control" locale="ptBR" dateFormat="dd/MM/yyyy" placeHolder="DD/MM/AAAA"
                                        customInput={
                                            <MaskedInput mask="11/11/1111" placeholder="mm/dd/yyyy" />
                                            } />
                                        
                                                        
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Hora início</label>
                                        <InputMask mask="99:99" value={horaInicio} onChange={event => setHoraInicio(event.target.value)} class="form-control"  />
                                                        
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Hora término</label>
                                        <InputMask mask="99:99" value={horaTermino} onChange={event => setHoraTermino(event.target.value)} class="form-control"  />
                                                        
                                    </div>
                                </div>
                                <div class="col-md-9" style={{ display: 'none'}}>
                                    <div class="form-group">
                                        <label>E-mail responsável</label>
                                        <input type="text" class="form-control" placeholder="" value={email_responsavel} onChange={event => setEmail_responsavel(event.target.value)} maxLength="255"/>
                                                        
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Ativo </label>
                                        <select class="form-control" value={ativo} onChange={event => setAtivo(event.target.value)} >
                                            <option value="">[Selecione]</option>
                                            <option value={true}>Sim</option>
                                            <option value={false}>Não</option>

                                        </select>
                                                        
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label><font style={{ backgroundColor: '#faf48c'}}>Habilitar confirmação de presença</font>  </label>
                                        <select class="form-control" value={habPresenca} onChange={event => setHabPresenca(event.target.value)} >
                                            
                                            <option value={false}>Não</option>
                                            <option value={true}>Sim</option>
                                            
                                        </select>
                                                        
                                    </div>
                                </div>



                                <div class="col-md-12" style={{ display: linkDivulgacao ? 'table-row' : 'none'}}>
                                    <div class="form-group">
                                        <label>Link para divulgação </label>
                                        <input class="form-control" value={linkDivulgacao} disabled />
                                            
                                                        
                                    </div>
                                </div>
                                

                            </div>
                        </div>

                        
                        <div class="tab-pane fade" id="tab5">
                            <div class="panel-body">
                                
                                <FotosEvento evento_id={evento_id} linkAPI={linkAPI} totalizaFotosEvento={totalizaFotosEvento} />

                            </div>
                        </div>



                        <div class="tab-pane fade" id="tab2">
                            <div class="panel-body">


                            <button type="button" class="btn btn-success" onClick={() => exportarExcel()}>Exportar XLSX</button>&nbsp;
                            <button type="button" class="btn btn-info" onClick={() => enviaMailSelecao()}>Enviar e-mail selecionados</button>
                            <br/><br/>

                                
                                <div className="table-responsive">
                                    
                                <MaterialReactTable 

                                    columns={columns} 
                                    data={resultadoInscritos} 

                                    enableRowSelection={true}
                                    //enableMultiRowSelection={true}
                                    //getRowId={(row) => row.inscricao_id}
                                    //onRowSelectionChange={setRowSelection}
                                    //state={ rowSelection }
                                    getRowId={(originalRow) => originalRow.inscricao_id}
                                    onRowSelectionChange={setRowSelection}
                                    state={{ rowSelection }}

                                    localization={MRT_Localization_PT_BR}
                                    //rowsPerPage={20}
                                    //options={options}
                                    initialState={{ 
                                        density: 'compact',
                                        sorting: [
                                            {
                                              id: 'data_inscricao', //sort by age by default on page load
                                              desc: true,
                                            },
                                            
                                          ],
                                     }}
                                    muiTableHeadCellProps={{
                                        //easier way to create media queries, no useMediaQuery hook needed.
                                        sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                        },
                                    }}
                                    muiTableBodyCellProps={{
                                        sx: {
                                            fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                            },
                                        },
                                    }}
                                    muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        //row.getToggleSelectedHandler();
                                        //get_Row({ row, staticRowIndex, table })(event);
                                        //console.info(event, row.original.usuario_id);
                                        //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                        //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                        //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                        //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                        //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setEnergia_id(row.original.energia_id); window.$("#modalEnergia").modal('show')
                                        //categoria_adesao == 'G' ? '#modalPerfilAnualCorp' : '#modalPerfilAnual' } onClick={() => 
                                        //setAdesaoInstitucionalId(row.original.adesao_institucional_id);setAno(row.original.ano);window.$(`${ row.original.categoria_adesao == 'G' ? '#modalPerfilAnualCorp' : '#modalPerfilAnual' }`).modal('show')
                                        //data-target="#modalInscritoEvento" onClick={() => { setInscricao_id(rs.inscricao_id); setCPF(rs.cpf)}}
                                        setInscricao_id(row.original.inscricao_id); setCPF(row.original.cpf);window.$('#modalInscritoEvento').modal('show')
                                    },
                                    sx: {
                                        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                    })}
                                    />
                                
                                </div>

                            </div>
                        </div>

                        <div class="tab-pane fade" id="tab6">
                            <div class="panel-body">
                                
                                

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Banner atual</label>
                                        <input type="text" className="form-control" placeholder="" value={imagemBanner} readOnly style={{cursor: imagemBanner ? 'pointer' : 'auto' }} onClick={() => imagemBanner ? window.open(`${linkAPI}/uploads/banners/${imagemBanner}`) : ''}/>
                                        
                                                        
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Upload novo banner</label>
                                        <input type="file" className="form-control" id="fileImgBanner" value={fileBanner} onChange={event => setFileBanner(event.target.value)} />
                                                        
                                    </div>
                                </div>

                                <div class="col-md-12">

                                    <br/>
                                    
                                    <button type="button" class="btn btn-warning" onClick={() => uploadBanner()}>Upload template</button>
                                </div>

                            </div>
                        </div>


                        <div class="tab-pane fade" id="tab3">
                            <div class="panel-body">
                                
                                

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Template atual</label>
                                        <input type="text" className="form-control" placeholder="" value={imagem} readOnly style={{cursor: imagem ? 'pointer' : 'auto' }} onClick={() => imagem ? window.open(`${linkAPI}/uploads/certificados/${imagem}`) : ''}/>
                                        
                                                        
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Upload novo template</label>
                                        <input type="file" className="form-control" id="fileImgCert" value={file} onChange={event => setFile(event.target.value)} />
                                                        
                                    </div>
                                </div>

                                <div class="col-md-12">

                                    <br/>
                                    
                                    <button type="button" class="btn btn-warning" onClick={() => uploadTemplate()}>Upload template</button>
                                </div>

                            </div>
                        </div>

                        <div class="tab-pane fade" id="tab4">
                            <div class="panel-body">
                                
                                <div class="col-md-12">

                                        {
                                        /*
                                        content &&
                                        <CKEditor 
                                        
                                        initData={content} 
                                        onReady={editor=>{}}
                                        //onChange={changeHeaderText}
                                        onChange={ event => setContent(event.editor.getData())}
                                        
                                        /> 
                                        */
                                        }

                                        <JoditEditor 
                                        ref={editor}
                                        value={content}
                                        config={config}
                                        tabIndex={1} // tabIndex of textarea
                                        onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                        onChange={newContent => {}}
                                        />

                                                        
                                </div>


                            </div>
                        </div>

                    </div>
                                

                        
                </div>

                <div class="col-md-12">

                    <br/>
                                    
                    <button type="button" class="btn btn-info" onClick={() => voltar()}>Voltar</button>&nbsp;
                    <button type="button" class="btn btn-danger" onClick={() => apagar()} style={{ display: !isNaN(evento_id) ? 'table-row' : 'none'}}>Apagar</button>&nbsp;
                    <button type="button" class="btn btn-primary" onClick={() => salvar()}>Salvar</button>
                </div>


                

            </div>


            <ModalInscritoEvento inscricao_id={inscricao_id} cpf={cpf} tipo={tipo} inscritos={inscritos} carregaEvento={carregaEvento}/>
            
            <ModalEmailConfirmacaoMassa inscricao_id_array={inscricao_id_array} tipo={tipo} evento_id={evento_id} inscritos={inscritos} tipoEmail={'C'}/>


        </div>

    )

}


export default Evento